export const isEqual = (a: any, b: any) => {
  if (a === b) return true;

  if (
    a === null ||
    typeof a !== "object" ||
    b === null ||
    typeof b !== "object"
  ) {
    return a === b;
  }

  if (Array.isArray(a) || Array.isArray(b)) {
    if (
      (Array.isArray(a) && !Array.isArray(b)) ||
      (!Array.isArray(a) && Array.isArray(b)) ||
      (Array.isArray(a) && Array.isArray(b) && a.length !== b.length)
    ) {
      return false;
    }

    for (let i = 0; i < a.length; i++) {
      const itemA = a[ i ];
      const itemB = b[ i ];

      if (!isEqual(itemA, itemB)) return false;
    }

    return true;
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!keysB.includes(key) || !isEqual(a[ key ], b[ key ])) {
      return false;
    }
  }

  return true;
};
